import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";

import {
    TableBody,
    Table,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    tableCellClasses,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { getMyDevicesData } from "../../Request.d";
import { FEATURE_CUSTOM_REDUX_V3 } from "../../../constant";
import { showApiLoader } from "../../../redux/tool-webjam/actions";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "var(--theme-primary-color)",
      color: theme.palette.common.white,
      fontSize: 16,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 16,
    },
  }));
  

function MyDevices(props) {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(showApiLoader());
        dispatch(getMyDevicesData());
    }, []);
    
    let { myDevicesData } = useSelector(
        (state) => state[FEATURE_CUSTOM_REDUX_V3]
      );

    return (    
        <>
            <div className="payment-table-custom-cont">
                <TableContainer>
                    <Table stickyHeader aria-label="custom pagination table">
                    <TableHead>
                        <TableRow>
                        <StyledTableCell>Device Name</StyledTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                
                        { !myDevicesData?.data?.device_id?.length && (
                        <TableRow className="w-100">
                            <StyledTableCell
                            colSpan={6}
                            style={{ textAlign: "center" }}
                            >
                            No device found
                            </StyledTableCell>
                        </TableRow>
                        )}
                        {(myDevicesData?.data?.device_id || []).map(
                        (item, i) => {
                            return (
                            <TableRow key={i} hover>
                                <StyledTableCell>
                                    {item || "-"}
                                </StyledTableCell>
                            </TableRow>
                            );
                        }
                        )}
                    </TableBody>
                    </Table>
                </TableContainer>
            </div>
        </>
    )
}

export default MyDevices;